import React from "react";
import classNames from "classnames";
import { PROXIMITY_LEVELS } from "../../utils";
import * as styles from "./styles.module.scss";
const ProximityMap = ({ className }) => (React.createElement("div", { className: classNames(styles.map, className) },
    React.createElement("p", { className: styles.label }, "Result proximity"),
    React.createElement("ul", { className: styles.list }, [...Array(PROXIMITY_LEVELS).keys()].map((index) => (React.createElement("li", { key: index, className: styles.item, style: { opacity: 0.1 * (index + 1) } })))),
    React.createElement("div", { className: styles.limits },
        React.createElement("p", null, "Far away"),
        React.createElement("p", null, "Close"))));
export default ProximityMap;
